export default __webpack_public_path__ + "static/media/deadlydraw.4f0d760d.png";